module.exports = __webpack_public_path__ + "img/62.e3431fa6.png";